// @ts-strict-ignore
export class CameraParametersVO {
  public lookAtPositionX: number;
  public lookAtPositionY: number;
  public lookAtPositionZ: number;

  public cameraPositionX: number;
  public cameraPositionY: number;
  public cameraPositionZ: number;

  public upVectorX: number;
  public upVectorY: number;
  public upVectorZ: number;

  public scale: number;

  public viewWidth: number;
  public viewHeight: number;
}
